import { ApprovalConfigPermission } from "../../../../../@client/Absents_ConfigApi"
import { AbsenceConfigValidationError } from "../../../../../@client/Theasoft_Absences_Config"

const canModify: ApprovalConfigPermission = { Case: "Denied", Fields: "" }

export const AbsenceContext = React.createContext<{
  showIds: boolean
  canModify: ApprovalConfigPermission
  isReadonly: boolean
  validationErrors: AbsenceConfigValidationError[] | null
}>({
  showIds: false,
  canModify: canModify,
  isReadonly: true,
  validationErrors: null,
})

export function useAbsenceConfigContext() {
  const ctx = React.useContext(AbsenceContext)
  if (!ctx) {
    throw new Error(
      "Cannot use useAbsenceConfigContext outside of AbsenceContigContext"
    )
  }
  return ctx
}
